import { startLoader, stopLoader } from "../../../libs/utils";
import Swal from "sweetalert2";
import { Button } from "@mui/material";

import {
  // getBankUserInfo,
  getTransactionDetails,
  syncTxnStatusFromL2,
  switchTransactionPartner,
  forceReturnTransaction,
} from "../../../services/user";

const TxnActions = ({
  searchUser,
  transaction_ref_id,
  setBankUserInfo,
  partner_switch_eligible,
  remittance_partner,
}) => {
  const syncL2TxnStatus = async () => {
    startLoader();
    try {
      const result = await syncTxnStatusFromL2(transaction_ref_id);
      stopLoader();
      const { success, error } = result || {};
      if (success) {
        setBankUserInfo({});
        Swal.fire({
          title: "Success",
          text: "Transaction status is synced successfully from Layer2!",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          searchUser();
        });
        return;
      }
      const message = error?.message || "Something went wrong!";
      Swal.fire({
        title: "Oops",
        text: message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      stopLoader();
      Swal.fire({
        title: "Oops",
        text: error.data?.error?.message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleSwitchPartner = async () => {
    startLoader();
    try {
      const result = await switchTransactionPartner(
        transaction_ref_id,
        "THUNES",
      );
      stopLoader();
      const { success, error } = result || {};
      if (success) {
        setBankUserInfo({});
        Swal.fire({
          title: "Success",
          text: "Transaction partner has been switched successfully!",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          searchUser();
        });
        return;
      }
      const message = error?.message || "Something went wrong!";
      Swal.fire({
        title: "Oops",
        text: message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      stopLoader();
      Swal.fire({
        title: "Oops",
        text: error.data?.error?.message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };

  const handleForceReturn = async () => {
    startLoader();
    try {
      const result = await forceReturnTransaction(transaction_ref_id);
      stopLoader();
      const { success, error } = result || {};
      if (success) {
        setBankUserInfo({});
        Swal.fire({
          title: "Success",
          text: "Transaction has been returned successfully!",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(() => {
          searchUser();
        });
        return;
      }
      const message = error?.message || "Something went wrong!";
      Swal.fire({
        title: "Oops",
        text: message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    } catch (error) {
      stopLoader();
      Swal.fire({
        title: "Oops",
        text: error.data?.error?.message,
        icon: "warning",
        confirmButtonText: "Ok",
      });
    }
  };
  return (
    <div className="col-md-12">
      {remittance_partner === "LAYER2" && (
        <Button onClick={syncL2TxnStatus} variant="contained" sx={{ mr: 2 }}>
          Sync Transaction Status from Layer2
        </Button>
      )}
      {partner_switch_eligible && (
        <Button
          onClick={handleSwitchPartner}
          variant="contained"
          sx={{ mr: 2, marginLeft: "16px !important" }}
        >
          Switch Transaction to THUNES
        </Button>
      )}
      <Button
        onClick={handleForceReturn}
        variant="contained"
        sx={{ marginLeft: "16px !important" }}
      >
        Return Transaction
      </Button>
    </div>
  );
};

export default TxnActions;
